// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.file-import-dialog {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
  color: var(--ca-text-primary, #172033);
  background: var(--ca-surface, #fff);
  border-radius: var(--ca-radius-lg, 12px);
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.4rem 1.5rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: #fff;
}

.header-icon {
  display: grid;
  place-items: center;
  width: 2.8rem;
  height: 2.8rem;
  flex: 0 0 2.8rem;
  border-radius: 10px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.25rem;
}

.header-content {
  flex: 1;
  min-width: 0;
}

.header-content h2 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
}

.header-content p {
  margin: 0.35rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
  overflow-wrap: anywhere;
}

.source-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.65rem;
}

.meta-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.6rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-bg, #f5f7fb);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.72rem;
  font-weight: 650;
}

.close-button {
  display: grid;
  place-items: center;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--ca-text-secondary, #4b5870);
  cursor: pointer;
}

.close-button:hover:not(:disabled) {
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-primary, #172033);
}

.close-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.dialog-body {
  overflow: auto;
  padding: 1.5rem;
}

.section-heading,
.assets-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.section-heading h3,
.assets-heading h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.section-heading p,
.assets-heading p {
  margin: 0.3rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.file-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  min-height: 225px;
  padding: 1.5rem;
  border: 1.5px dashed var(--ca-border-dark, #c7cfdd);
  border-radius: 12px;
  background: var(--ca-bg, #f5f7fb);
  text-align: center;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.file-dropzone:hover,
.file-dropzone.has-file {
  border-color: var(--ca-primary, #0e2e80);
  background: #f7f9ff;
}

.dropzone-icon {
  display: grid;
  place-items: center;
  width: 3.2rem;
  height: 3.2rem;
  margin-bottom: 0.3rem;
  border-radius: 12px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.5rem;
}

.file-selected-icon {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.file-dropzone strong {
  max-width: 100%;
  font-size: 0.9rem;
  overflow-wrap: anywhere;
}

.dropzone-description {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.format-hint {
  margin-top: 0.35rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.74rem;
}

.browse-button {
  margin-top: 0.35rem;
  cursor: pointer;
}

.selected-file-name {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.text-button {
  padding: 0.25rem 0.4rem;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;
}

.text-button:hover:not(:disabled) {
  text-decoration: underline;
}

.text-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.status-message {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 1rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 8px;
  font-size: 0.82rem;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.status-message > i,
.status-message > span:first-child {
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.status-error {
  border-color: var(--ca-danger-bg, #fdecef);
  background: #fff7f8;
  color: #b42332;
}

.status-success {
  border-color: var(--ca-success-bg, #eaf7f0);
  background: #f5fbf7;
  color: var(--ca-text-secondary, #4b5870);
}

.upload-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.25rem;
}

.upload-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.55rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.84rem;
  font-weight: 650;
}

.upload-actions .btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.upload-actions .btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

.upload-actions .btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.assets-section {
  margin-top: 1.75rem;
  padding-top: 1.4rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.assets-heading {
  align-items: center;
}

.count-pill {
  flex-shrink: 0;
  padding: 0.35rem 0.65rem;
  border: 1px solid rgba(40, 80, 173, 0.13);
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.75rem;
  font-weight: 700;
}

.assets-table-wrapper {
  max-height: 350px;
  overflow: auto;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 8px;
}

.assets-table {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.8rem;
}

.assets-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.8rem;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
  background: #f4f6fa;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.7rem;
  font-weight: 750;
  text-transform: uppercase;
  white-space: nowrap;
}

.assets-table tbody td {
  padding: 0.8rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  color: var(--ca-text-secondary, #4b5870);
  vertical-align: top;
}

.assets-table tbody tr:last-child td {
  border-bottom: 0;
}

.assets-table tbody tr:hover {
  background: #f8faff;
}

.assets-table td strong {
  display: block;
  color: var(--ca-text-primary, #172033);
  font-weight: 650;
}

.asset-description {
  display: block;
  max-width: 300px;
  margin-top: 0.25rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.73rem;
  overflow-wrap: anywhere;
}

.status-pill {
  display: inline-flex;
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.72rem;
  white-space: nowrap;
}

.empty-state {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.45rem;
  padding: 2rem 1rem;
  border: 1px dashed var(--ca-border, #dfe4ec);
  border-radius: 10px;
  background: var(--ca-bg, #f5f7fb);
  text-align: center;
}

.empty-state > i {
  margin-bottom: 0.25rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.7rem;
}

.empty-state strong {
  font-size: 0.9rem;
}

.empty-state span {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
}

@media (max-width: 640px) {
  .dialog-header {
    padding: 1rem;
  }
  .dialog-body {
    padding: 1rem;
  }
  .file-dropzone {
    min-height: 190px;
    padding: 1rem;
  }
  .upload-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .upload-actions .btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/system-asset-capture/system-assets-capture-for-file-asset-source/system-assets-capture-for-file-asset-source.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,mCAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;EACA,wDAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;EACA,oBAAA;EACA,iCAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;AACF;;AAEA;EACE,2CAAA;EACA,sCAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;;EAEE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,SAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,wCAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,mDAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gEACE;AAAJ;;AAIA;;EAEE,wCAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AADF;;AAIA;EACE,yCAAA;EACA,iCAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;AADF;;AAIA;EACE,wCAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,uBAAA;AADF;;AAIA;EACE,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,0BAAA;AADF;;AAIA;EACE,mBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AADF;;AAIA;;EAEE,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,0CAAA;EACA,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,2CAAA;EACA,mBAAA;EACA,wCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,wCAAA;EACA,sCAAA;EACA,WAAA;AADF;;AAIA;EACE,6CAAA;EACA,2CAAA;AADF;;AAIA;EACE,mBAAA;EACA,aAAA;AADF;;AAIA;EACE,mBAAA;EACA,mBAAA;EACA,qDAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,wBAAA;EACA,yCAAA;EACA,oBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,cAAA;EACA,iDAAA;EACA,kBAAA;AADF;;AAIA;EACE,SAAA;EACA,sCAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;EACA,kDAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,wDAAA;EACA,wCAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,sCAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,uBAAA;AADF;;AAIA;EACE,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2CAAA;EACA,wCAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;AADF;;AAIA;EACE,sBAAA;EACA,iCAAA;EACA,iBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,wCAAA;EACA,iBAAA;AADF;;AAIA;EACE;IACE,aAAA;EADF;EAIA;IACE,aAAA;EAFF;EAKA;IACE,iBAAA;IACA,aAAA;EAHF;EAMA;IACE,oBAAA;IACA,8BAAA;EAJF;EAOA;IACE,WAAA;EALF;AACF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.file-import-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  overflow: hidden;\n  color: var(--ca-text-primary, #172033);\n  background: var(--ca-surface, #fff);\n  border-radius: var(--ca-radius-lg, 12px);\n}\n\n.dialog-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.4rem 1.5rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: #fff;\n}\n\n.header-icon {\n  display: grid;\n  place-items: center;\n  width: 2.8rem;\n  height: 2.8rem;\n  flex: 0 0 2.8rem;\n  border-radius: 10px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.25rem;\n}\n\n.header-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.header-content h2 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n}\n\n.header-content p {\n  margin: 0.35rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.88rem;\n  overflow-wrap: anywhere;\n}\n\n.source-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.65rem;\n}\n\n.meta-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.3rem 0.6rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 999px;\n  background: var(--ca-bg, #f5f7fb);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.72rem;\n  font-weight: 650;\n}\n\n.close-button {\n  display: grid;\n  place-items: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  flex: 0 0 2.25rem;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--ca-text-secondary, #4b5870);\n  cursor: pointer;\n}\n\n.close-button:hover:not(:disabled) {\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-primary, #172033);\n}\n\n.close-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.dialog-body {\n  overflow: auto;\n  padding: 1.5rem;\n}\n\n.section-heading,\n.assets-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.section-heading h3,\n.assets-heading h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.section-heading p,\n.assets-heading p {\n  margin: 0.3rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n}\n\n.file-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  min-height: 225px;\n  padding: 1.5rem;\n  border: 1.5px dashed var(--ca-border-dark, #c7cfdd);\n  border-radius: 12px;\n  background: var(--ca-bg, #f5f7fb);\n  text-align: center;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.file-dropzone:hover,\n.file-dropzone.has-file {\n  border-color: var(--ca-primary, #0e2e80);\n  background: #f7f9ff;\n}\n\n.dropzone-icon {\n  display: grid;\n  place-items: center;\n  width: 3.2rem;\n  height: 3.2rem;\n  margin-bottom: 0.3rem;\n  border-radius: 12px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.5rem;\n}\n\n.file-selected-icon {\n  background: var(--ca-success-bg, #eaf7f0);\n  color: var(--ca-success, #198754);\n}\n\n.file-dropzone strong {\n  max-width: 100%;\n  font-size: 0.9rem;\n  overflow-wrap: anywhere;\n}\n\n.dropzone-description {\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n}\n\n.format-hint {\n  margin-top: 0.35rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.74rem;\n}\n\n.browse-button {\n  margin-top: 0.35rem;\n  cursor: pointer;\n}\n\n.selected-file-name {\n  max-width: 100%;\n  overflow-wrap: anywhere;\n}\n\n.text-button {\n  padding: 0.25rem 0.4rem;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.82rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.text-button:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.text-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.status-message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  margin-top: 1rem;\n  padding: 0.8rem 0.9rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 8px;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n.status-message > i,\n.status-message > span:first-child {\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n\n.status-error {\n  border-color: var(--ca-danger-bg, #fdecef);\n  background: #fff7f8;\n  color: #b42332;\n}\n\n.status-success {\n  border-color: var(--ca-success-bg, #eaf7f0);\n  background: #f5fbf7;\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.upload-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n}\n\n.upload-actions .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.55rem;\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.84rem;\n  font-weight: 650;\n}\n\n.upload-actions .btn-primary {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n\n.upload-actions .btn-primary:hover:not(:disabled) {\n  border-color: var(--ca-primary-dark, #0d2863);\n  background: var(--ca-primary-dark, #0d2863);\n}\n\n.upload-actions .btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.assets-section {\n  margin-top: 1.75rem;\n  padding-top: 1.4rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.assets-heading {\n  align-items: center;\n}\n\n.count-pill {\n  flex-shrink: 0;\n  padding: 0.35rem 0.65rem;\n  border: 1px solid rgba(40, 80, 173, 0.13);\n  border-radius: 999px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.assets-table-wrapper {\n  max-height: 350px;\n  overflow: auto;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 8px;\n}\n\n.assets-table {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.8rem;\n}\n\n.assets-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 0.8rem;\n  border-bottom: 1px solid var(--ca-border, #dfe4ec);\n  background: #f4f6fa;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.7rem;\n  font-weight: 750;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.assets-table tbody td {\n  padding: 0.8rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  color: var(--ca-text-secondary, #4b5870);\n  vertical-align: top;\n}\n\n.assets-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.assets-table tbody tr:hover {\n  background: #f8faff;\n}\n\n.assets-table td strong {\n  display: block;\n  color: var(--ca-text-primary, #172033);\n  font-weight: 650;\n}\n\n.asset-description {\n  display: block;\n  max-width: 300px;\n  margin-top: 0.25rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.73rem;\n  overflow-wrap: anywhere;\n}\n\n.status-pill {\n  display: inline-flex;\n  padding: 0.25rem 0.5rem;\n  border-radius: 999px;\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.empty-state {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding: 2rem 1rem;\n  border: 1px dashed var(--ca-border, #dfe4ec);\n  border-radius: 10px;\n  background: var(--ca-bg, #f5f7fb);\n  text-align: center;\n}\n\n.empty-state > i {\n  margin-bottom: 0.25rem;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.7rem;\n}\n\n.empty-state strong {\n  font-size: 0.9rem;\n}\n\n.empty-state span {\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.8rem;\n}\n\n@media (max-width: 640px) {\n  .dialog-header {\n    padding: 1rem;\n  }\n\n  .dialog-body {\n    padding: 1rem;\n  }\n\n  .file-dropzone {\n    min-height: 190px;\n    padding: 1rem;\n  }\n\n  .upload-actions {\n    align-items: stretch;\n    flex-direction: column-reverse;\n  }\n\n  .upload-actions .btn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
